import { Link } from 'found'
import React, { Component } from 'react'
import { createFragmentContainer } from 'react-relay'
import graphql from 'babel-plugin-relay/macro' 

function PromotedSection({ title, subtitle, callToAction, leftPicture, rightPicture, onlineStoreLink }) {

    return (
        <div className="books-banner">
            <div className="row-13 w-row">
                <div className="column-33 w-col w-col-6">
                    <div className="w-clearfix">
                        <img alt="" src={leftPicture} width={304} className="image-26" />
                        <img alt="" src={rightPicture} width={316} className="image-25" />
                    </div>
                </div>
                <div className="column-34 w-col w-col-6">
                    <div className="text-block-14">{title}</div>
                    <p className="paragraph-2">{subtitle}</p>
                    <Link
                        to={onlineStoreLink}
                        style={{ textTransform: 'uppercase' }}
                        className="buy-the-book w-button"
                    >
                        {callToAction}
                    </Link>
                </div>
            </div>
        </div>
    )
}

const connectRelay = PromotedSection => class extends Component {

    render() {
        const { routeResolver } = this.props.context
        const props = {
            onlineStoreLink: routeResolver.onlineStore.get(),
            ...this.props.home.promotedContent
        }
        return <PromotedSection {...props} />
    }
}

export default createFragmentContainer(
    connectRelay(PromotedSection),
    graphql`
        fragment promotedSection_home on Home {
            promotedContent {
                title
                subtitle
                callToAction
                leftPicture
                rightPicture
            }
        }
    `
)
